import _ from 'lodash';
import React from 'react';
import numeral from 'numeral';
import classnames from 'classnames';
import greScales from './greScales';
import styles from './styles.scss';

const getSummaryClassFromScore = (score) => {
  if (score >= 0.75) {
    return styles.high;
  }

  if (score >= 0.5) {
    return styles.medium;
  }

  return styles.low;
};

const ScoreContainer = (props) => {
  const { product, score, points, userExam } = props;

  // 20210306JP: In debug mode, we might not have a product.
  const productSlug = _.get(product, 'slug');

  const scorePercent = numeral(score).format('0%');

  if (userExam && productSlug === 'gre') {
    const { variant } = userExam;
    const greScaled = greScales({ variant, points });
    const { range, percentile } = greScaled;

    return (
      <div className={styles.scoreContainer}>
        <div data-aaa="examScorePercent" className={styles.score}>
          {range}*
        </div>
        <div className={styles.scoreSubtext}>
          *This predicted score range is an estimate based on your {scorePercent} raw
          score for this section, which corresponds to the {percentile} percentile.
        </div>
      </div>
    );
  }

  return (
    <div className={styles.scoreContainer}>
      <div data-aaa="examScorePercent" className={styles.score}>
        {scorePercent}
      </div>
    </div>
  );
};

const GenericSummary = (props) => {
  const { extra, product, title, score, summary, userExam } = props;
  const productName = _.get(product, 'name');

  const points = _.sumBy(summary, 'correct');
  const pointsTotal = _.sumBy(summary, 'total');

  return (
    <div className={styles.layout}>
      <div className={styles.layoutInner}>
        <div className={classnames(styles.ready, styles.exam)}>
          <div>{title}</div>
          <div>
            <b>{productName}</b>
          </div>
          <ScoreContainer
            product={product}
            score={score}
            points={points}
            userExam={userExam}
          />
          {pointsTotal ? (
            <>
              <div className={styles.scoreSummary}>
                {summary.map((summaryObj) => {
                  const { key, correct, total, name } = summaryObj;
                  const summaryClass = getSummaryClassFromScore(correct / total);
                  return (
                    <div key={key} className={styles.scoreSummaryRow}>
                      <div
                        className={classnames(styles.scoreSummaryCounts, summaryClass)}
                      >
                        {correct} / {total}
                      </div>
                      <div className={styles.scoreSummaryName}>{name}</div>
                    </div>
                  );
                })}
                <div className={styles.scoreSummaryFooter}>
                  <div data-aaa="examScorePoints" className={styles.scoreSummaryCounts}>
                    {points} / {pointsTotal}
                  </div>
                  <div className={styles.scoreSummaryName}>Total</div>
                </div>
              </div>
            </>
          ) : null}
          {extra}
        </div>
      </div>
    </div>
  );
};

export default GenericSummary;
